import { render, staticRenderFns } from "./PayTypeAmount.vue?vue&type=template&id=14235310&scoped=true"
import script from "./PayTypeAmount.vue?vue&type=script&lang=js"
export * from "./PayTypeAmount.vue?vue&type=script&lang=js"
import style0 from "./PayTypeAmount.vue?vue&type=style&index=0&id=14235310&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14235310",
  null
  
)

export default component.exports